
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWaypointOptionalIec as ObiWaypointOptionalIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-waypoint-optional-iec.js';
 
 
 

 
 export const ObiWaypointOptionalIec = createComponent({
   react: React,
   tagName: 'obi-waypoint-optional-iec',
   elementClass: ObiWaypointOptionalIecElement,
   events: {
     
   }
  });
 
 